import {
  GET_DATA_KOMITE,
  GET_KATEGORI_KOMITE,
  SET_LOADING_DATA_KOMITE,
  SET_LOADING_KATEGORI_KOMITE,
  SET_PAGINATION_DATA_KOMITE,
  SET_PAGINATION_KATEGORI_KOMITE,
} from '../constant';

const initialState = {
  kategori: [],
  loadingKategori: false,
  kategoriPagination: 0,
  totalKategori: 0,
  data: [],
  loadingData: false,
  dataPagination: 0,
  totalData: 0,
};

const KomiteGCGReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_LOADING_KATEGORI_KOMITE: {
      return {
        ...state,
        loadingKategori: action?.payload,
      };
    }
    case SET_PAGINATION_KATEGORI_KOMITE: {
      return {
        ...state,
        kategoriPagination: action?.payload,
      };
    }
    case GET_KATEGORI_KOMITE: {
      return {
        ...state,
        kategori: action?.payload?.data,
        totalKategori: action?.payload?.total,
        loadingKategori: false,
      };
    }
    case SET_LOADING_DATA_KOMITE: {
      return {
        ...state,
        loadingData: action?.payload,
      };
    }
    case SET_PAGINATION_DATA_KOMITE: {
      return {
        ...state,
        dataPagination: action?.payload,
      };
    }
    case GET_DATA_KOMITE: {
      return {
        ...state,
        data: action?.payload?.data || [],
        totalData: action?.payload?.total,
        loadingData: false,
      };
    }
    default: {
      return state;
    }
  }
};

export default KomiteGCGReducer;
